import type { ModuleKey } from './biModuleRegistry';

/** Lijepi avatar (ikona + gradijent) za svaki modul — koristi se na landing stranici i shortcutima. */
export type ModuleAvatar = { icon: string; grad: [string, string] };

const GOLD: [string, string] = ['#c99b31', '#6b4f1c'];

// 'profile' je pseudo-ključ (profil usera), nije modul — zato širi tip od ModuleKey.
const MAP: Partial<Record<ModuleKey | 'profile', ModuleAvatar>> = {
    dashboard: { icon: '🏠', grad: ['#c99b31', '#8a6817'] },
    ado: { icon: '💰', grad: ['#e6b94e', '#a9781b'] },
    ado_1111: { icon: 'Au', grad: ['#e6b94e', '#6b4f1c'] },
    ado_1112: { icon: 'Au', grad: ['#f0c14b', '#0e0a07'] },
    buyback: { icon: '♻️', grad: ['#d4a44a', '#7c5e1c'] },
    pnl: { icon: '📈', grad: ['#3e9b6c', '#1f6e45'] },
    uprava_pl: { icon: 'PL', grad: ['#3e9b6c', '#1f6e45'] },
    uprava_dash: { icon: 'UD', grad: ['#444444', '#111111'] },
    pnl_kocka: { icon: 'PK', grad: ['#3e9b6c', '#1f6e45'] },
    pnl_explorer: { icon: 'PX', grad: ['#3e9b6c', '#1f6e45'] },
    payroll: { icon: '💸', grad: ['#5a8fd6', '#2f5fa3'] },
    hedging: { icon: '🛡️', grad: ['#7d96b3', '#3c5575'] },
    hedging_stonex: { icon: '📡', grad: ['#6b87a8', '#33506f'] },
    hedging_market_dashboard: { icon: '📊', grad: ['#5b7a9a', '#2c4560'] },
    loans: { icon: '🏦', grad: ['#8a7fc0', '#534a8f'] },
    cashflow: { icon: '💧', grad: ['#4fb6c9', '#1f7d92'] },
    marketing: { icon: '📣', grad: ['#e07a5f', '#b14a30'] },
    circulars: { icon: '📨', grad: ['#c99b31', '#6b4f1c'] },
    mailing: { icon: '✉️', grad: ['#d08b5a', '#8a531f'] },
    sops: { icon: '🎓', grad: ['#b07ec0', '#724a82'] },
    education: { icon: '📚', grad: ['#c99b31', '#6b4f1c'] },
    knjigovodstvo: { icon: '📒', grad: ['#5a8f6a', '#2f5e3c'] },
    pentest_monitor: { icon: '🕵️', grad: ['#5d6470', '#2c313a'] },
    tasks: { icon: '✅', grad: ['#3e9b6c', '#1f6e45'] },
    hr: { icon: '🧑‍💼', grad: ['#5a8fd6', '#3a3f8f'] },
    price_triggers: { icon: '🎯', grad: ['#b8923a', '#6b4f1c'] },
    posrednici: { icon: '🤝', grad: ['#b8923a', '#6b4f1c'] },
    parcels: { icon: '📦', grad: ['#c97f31', '#7c4f1c'] },
    team_tasks: { icon: '👥', grad: ['#4f9bb6', '#2f6e85'] },
    personal_asana: { icon: '🗂️', grad: ['#d08b5a', '#8a531f'] },
    zapisnici: { icon: '📝', grad: ['#9a8bc0', '#5a4d8f'] },
    poslovnice: { icon: '🏬', grad: ['#c99b31', '#7c5e1c'] },
    related_sales: { icon: '🌍', grad: ['#4fb6c9', '#1f7d92'] },
    presentation: { icon: '💎', grad: ['#5fb0c9', '#2f7d92'] },
    presentation_newsletters: { icon: '📰', grad: ['#7d96b3', '#3c5575'] },
    presentation_customer: { icon: '🤝', grad: ['#e6b94e', '#a9781b'] },
    bank_ready: { icon: '🏛️', grad: ['#8a7fc0', '#534a8f'] },
    documentation: { icon: '📁', grad: ['#d4a44a', '#7c5e1c'] },
    payment_traffic: { icon: '💳', grad: ['#5a8fd6', '#2f5fa3'] },
    payment_reconciliation: { icon: '⚖️', grad: ['#5a8fd6', '#26436f'] },
    platni_cf: { icon: '💸', grad: ['#c99b31', '#6b4f1c'] },
    payment_selection: { icon: '🧾', grad: ['#d68f5a', '#a3582f'] },
    payment_batches: { icon: '🗓️', grad: ['#5aa0d6', '#2f6aa3'] },
    contracts: { icon: '📜', grad: ['#a07fc0', '#5e4a8f'] },
    buyback_payout: { icon: '💵', grad: ['#4fb37a', '#1f7d4d'] },
    monestiq: { icon: '🏧', grad: ['#3e9b6c', '#1f6e45'] },
    monestiq_finance: { icon: '💹', grad: ['#3e9b6c', '#1f6e45'] },
    monestiq_atm: { icon: '🏧', grad: ['#5a8f6a', '#2f5e3c'] },
    warehouse: { icon: '📦', grad: ['#d08b5a', '#8a531f'] },
    warehouse_restock_prep: { icon: '🚚', grad: ['#7d96b3', '#3c5575'] },
    warehouse_branch_restock: { icon: '📦', grad: ['#7d96b3', '#3c5575'] },
    warehouse_import_orders: { icon: '🧾', grad: ['#7d96b3', '#3c5575'] },
    warehouse_tca_invoices: { icon: '🏭', grad: ['#7d96b3', '#3c5575'] },
    warehouse_gtm_scrap: { icon: '♻️', grad: ['#7d96b3', '#3c5575'] },
    warehouse_gold_cm: { icon: '🥇', grad: ['#e6b94e', '#a9781b'] },
    warehouse_summary_orders: { icon: '📋', grad: ['#c99b31', '#6b4f1c'] },
    warehouse_stock: { icon: '📦', grad: ['#d4a44a', '#7c5e1c'] },
    warehouse_plan_wizard: { icon: '🪄', grad: ['#b07ec0', '#724a82'] },
    warehouse_plan_generate: { icon: '🧮', grad: ['#7d96b3', '#3c5575'] },
    warehouse_roadmap: { icon: '🗺️', grad: ['#5d6470', '#2c313a'] },
    warehouse_gold_coverage: { icon: '⚖️', grad: ['#e6b94e', '#a9781b'] },
    warehouse_daily_inventory: { icon: '📋', grad: ['#c99b31', '#6b4f1c'] },
    warehouse_coverage_v2: { icon: '⚖️', grad: ['#8a8f98', '#474c55'] },
    warehouse_coverage_v3: { icon: '⚖️', grad: ['#8a8f98', '#474c55'] },
    warehouse_exposure_v2: { icon: '🌍', grad: ['#8a8f98', '#474c55'] },
    warehouse_lager_plan: { icon: '🧱', grad: ['#8a8f98', '#474c55'] },
    warehouse_insurance: { icon: '🛡️', grad: ['#6b7a8f', '#3a4556'] },
    admin: { icon: '⚙️', grad: ['#5d6470', '#2c313a'] },
    directory: { icon: '📇', grad: ['#4f9bb6', '#2f6e85'] },
    profile: { icon: '👤', grad: ['#8a7fc0', '#534a8f'] },
};

export function moduleAvatar(key: ModuleKey | string): ModuleAvatar {
    return MAP[key as ModuleKey] ?? { icon: '📌', grad: GOLD };
}
